const sanitizeFieldName = (fieldName: string) =>
  fieldName.replaceAll(/#/g, '%23').replaceAll(/\./g, '%2E').replaceAll(/ /g, '%20');

const restoreSanitizedFieldName = (fieldName: string) =>
  fieldName.replaceAll('%23', '#').replaceAll('%2E', '.').replaceAll('%20', ' ');

export { sanitizeFieldName, restoreSanitizedFieldName };
